export function isNum(rule, value, callback) {
  const age = /^[0-9]*$/
  if (!age.test(value)) {
    callback(new Error('只能为大于0的数字'))
  } else {
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/util/validator.js